import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { LandingNav } from "@/components/landing/LandingNav";
import { Container, ContourField, CtaLink } from "@/components/landing/primitives";
import { useLanguage } from "@/hooks/useLanguage";
import { localePath, makeTr } from "@/lib/landing/locale";
import { languageFromPath } from "@/lib/site/publicPages";

/** Any address that leads nowhere, in the public site's look. */
const NotFound = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const locale = languageFromPath(location.pathname) ?? (language === "en" ? "en" : "cs");
  const tr = makeTr(locale);
  // The nav's language switch keeps this address, so it stays a 404 in the other
  // language, and its section links lead back to the landing page.
  const path = location.pathname.replace(/^\/(cs|en)(?=\/|$)/, "") || "/404";

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div
      lang={locale}
      className="flex min-h-screen flex-col overflow-x-clip bg-background text-foreground antialiased"
    >
      <LandingNav locale={locale} path={path} />

      <main id="obsah" className="relative isolate flex flex-1 items-center overflow-hidden">
        <ContourField variant="hero" />
        <Container className="py-24 text-center sm:py-32">
          <p className="text-6xl font-semibold tabular-nums tracking-tight text-[hsl(var(--action))] dark:text-primary sm:text-7xl">
            404
          </p>
          <h1 className="mt-4 text-2xl font-semibold tracking-tight sm:text-3xl">
            {tr("Stránka nenalezena", "Page not found")}
          </h1>
          <p className="mt-2 text-muted-foreground">
            {tr("Tahle adresa nikam nevede.", "This address doesn't lead anywhere.")}
          </p>
          <div className="mt-8 flex justify-center">
            <CtaLink to={localePath(locale, "/")} arrow>
              {tr("Zpět na úvod", "Back to home")}
            </CtaLink>
          </div>
        </Container>
      </main>

      <LandingFooter locale={locale} path={path} />
    </div>
  );
};

export default NotFound;
